module.exports = __webpack_public_path__ + "static/img/logo2.9887cba6.png";